/**
 * Lancement de la caisse par l'appli TPE avec une adresse du Mode Stock (intent VIEW).
 * L'APK garde l'adresse reçue ; la page la prend au démarrage et à chaque nouvelle adresse
 * (événement « vp-launch-url » envoyé par l'APK). Sans APK compatible : rien ne se passe.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { parseLaunchUrl } from '@/features/pda/launchUrl';

type LaunchBridge = { take?: () => string };

const takeLaunchUrl = (): string | null => {
  try {
    const bridge = (window as unknown as { VisionPosLaunch?: LaunchBridge }).VisionPosLaunch;
    return bridge?.take?.() || null;
  } catch {
    return null;
  }
};

export function usePdaLaunchUrl() {
  const navigate = useNavigate();
  useEffect(() => {
    const open = () => {
      const target = parseLaunchUrl(takeLaunchUrl());
      if (target) navigate(target);
    };
    open();
    window.addEventListener('vp-launch-url', open);
    return () => window.removeEventListener('vp-launch-url', open);
  }, [navigate]);
}
